import { type SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import React, { createContext } from 'react';

type RowContextProps = {
  setActivatorNodeRef?: (element: HTMLElement | null) => void;
  listeners?: SyntheticListenerMap;
};

export const RowContext = createContext<RowContextProps | null>(null);

export const useRowContext = () => {
  const context = React.useContext(RowContext);
  if (!context) {
    throw new Error('useRowContext must be used within a RowContext');
  }
  return context;
};
